import type { DeepPartial } from '@luna/utils-ts';

import type { OwnFxTransfer } from './OwnFxTransfer';

export const HR: DeepPartial<OwnFxTransfer> = {};
